export default __webpack_public_path__ + "assets/ico_copy-a40f00f9.svg";